import type { ValueGetterParams } from 'ag-grid-community'
import { OrderRequestType } from './OrderGrid/OrderColumn'
import dayjs from 'dayjs'
import { formatters } from '@/utils/intl/dateTimeFormatters'
import { ScheduleData } from './OptimizerWizard/types'

export type OrderV1 = Gravitate.Order & {
  type: typeof OrderRequestType.OrderRequestRequested
  is_pending_v2_order_request: false
  site_name: string
  site_address: string
  site_city: string
  site_state: string
}

export function isOrderRequestV1(order: Gravitate.Order): order is OrderV1 {
  return order?.type === OrderRequestType.OrderRequestRequested && !order?.is_pending_v2_order_request
}

export function checkRunout(params: ValueGetterParams<Gravitate.Order>) {
  if (!params?.data?.dispatch_window_end) return ''

  const end = dayjs(params?.data?.dispatch_window_end)
  const now = dayjs().local()

  const matches = []
  if (end.isBefore(now.add(12, 'h'))) {
    matches.push('12 Hours')
  }
  if (end.isBefore(now.add(24, 'h'))) {
    matches.push('24 Hours')
  }
  if (end.isBefore(now.add(3, 'd'))) {
    matches.push('3 Days')
  }
  if (end.isBefore(now.add(7, 'd'))) {
    matches.push('Next Week')
  }

  return matches
}

export function formatShiftDate(data: Gravitate.Schedule) {
  const { shift_start: start, shift_end: end, shift_start_local: tz } = data
  if (!start && !end) return ''
  return `${formatters.MONTH_DATE_TIME_RANGE(start, end, tz)}`
}
